// components/TableHeader.jsx
import React, { useState } from 'react';
import dropdownIcon from '../../../../Assets/Icons/dropdownBlack.svg';

const TableHeader = ({ data, filters, onFilterChange }) => {
    const [openDropdown, setOpenDropdown] = useState(null);

    const uniqueValues = (key) =>
        [...new Set(data?.map(item => item[key]).filter(Boolean))];

    return (
        <thead className="bg-blue-100 sticky top-0 z-10">
            <tr>
                <th className="px-4 py-2 font-bold w-[6%]">Sr No</th>
                {['ComponentName', 'Category', 'Technology', 'ComponentState']?.map((key) => (
                    <th key={key} className="px-4 py-2 font-bold relative">
                        <div className="flex items-center gap-1">
                            {key}
                            <img
                                src={dropdownIcon}
                                alt="filter"
                                onClick={() => setOpenDropdown(openDropdown === key ? null : key)}
                                className="w-4 h-4 cursor-pointer"
                            />
                        </div>
                        {openDropdown === key && (
                            <div className="absolute z-20 bg-white shadow border rounded mt-1 max-h-60 overflow-y-auto">
                                <button
                                    onClick={() => onFilterChange(key, '')}
                                    className="block px-3 py-1 text-left hover:bg-gray-100"
                                >
                                    All
                                </button>
                                {uniqueValues(key)?.map((val, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => onFilterChange(key, val)}
                                        className="block px-3 py-1 text-left hover:bg-gray-100"
                                    >
                                        {val}
                                    </button>
                                ))}
                            </div>
                        )}
                    </th>
                ))}
                <th className="px-4 py-2 font-bold">Component Details</th>
                <th className="px-4 py-2 font-bold">Actions</th>
            </tr>
        </thead>
    );
};

export default TableHeader;
